module.exports = __webpack_public_path__ + "img/logo_rackon2.ab176b15.svg";